// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-tag-input {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

/* Selected tags chips */
.game-tag-input__selected {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
}

.game-tag-input__chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: var(--radius-full);
  font-family: var(--font-body);
  font-size: var(--font-size-body-sm);
  background: var(--color-fire-500);
  color: var(--color-parchment-100);
  line-height: 1.4;
}

.game-tag-input__chip-remove {
  background: none;
  border: none;
  color: var(--color-parchment-100);
  cursor: pointer;
  font-size: 14px;
  padding: 0 2px;
  line-height: 1;
  opacity: 0.8;
}

.game-tag-input__chip-remove:hover {
  opacity: 1;
}

/* Input row: field + submit button */
.game-tag-input__field-wrap {
  position: relative;
  display: flex;
  align-items: stretch;
}

.game-tag-input__field {
  flex: 1;
  min-width: 0;
  padding: var(--space-2) var(--space-3);
  border: 2px solid var(--color-wood-600);
  border-right: none;
  border-radius: var(--radius-md) 0 0 var(--radius-md);
  font-family: var(--font-body);
  font-size: var(--font-size-body-sm);
  background: var(--color-parchment-100);
  color: var(--color-text-primary);
  outline: none;
  transition: border-color var(--transition-fast);
  box-sizing: border-box;
}

.game-tag-input__field:focus {
  border-color: var(--color-fire-500);
}

.game-tag-input__field:focus + .game-tag-input__submit-btn {
  border-color: var(--color-fire-500);
}

.game-tag-input__submit-btn {
  flex-shrink: 0;
  width: 40px;
  border: 2px solid var(--color-wood-600);
  border-left: none;
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
  background: linear-gradient(135deg, var(--color-wood-700), var(--color-wood-600));
  color: var(--color-parchment-100);
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: background var(--transition-fast), opacity var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
}

.game-tag-input__submit-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, var(--color-fire-600), var(--color-fire-500));
}

.game-tag-input__submit-btn:disabled {
  opacity: 0.4;
  cursor: default;
}

/* Autocomplete suggestions dropdown */
.game-tag-input__suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--color-parchment-100);
  border: 2px solid var(--color-wood-600);
  border-top: none;
  border-radius: 0 0 var(--radius-md) var(--radius-md);
  box-shadow: var(--shadow-md);
  z-index: var(--z-dropdown);
  max-height: 200px;
  overflow-y: auto;
}

.game-tag-input__suggestion {
  display: block;
  width: 100%;
  padding: var(--space-2) var(--space-3);
  border: none;
  background: none;
  font-family: var(--font-body);
  font-size: var(--font-size-body-sm);
  color: var(--color-text-primary);
  text-align: left;
  cursor: pointer;
  transition: background var(--transition-fast);
}

.game-tag-input__suggestion:hover {
  background: var(--color-wood-600);
  color: var(--color-parchment-100);
}

/* Collapsible all-tags section */
.game-tag-input__all-tags {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.game-tag-input__toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  background: none;
  border: none;
  padding: var(--space-1) 0;
  font-family: var(--font-body);
  font-size: var(--font-size-body-sm);
  font-weight: 600;
  color: var(--color-text-secondary);
  cursor: pointer;
  user-select: none;
  transition: color var(--transition-fast);
}

.game-tag-input__toggle-btn:hover {
  color: var(--color-fire-600);
}

.game-tag-input__toggle-icon {
  display: inline-block;
  transition: transform var(--transition-fast);
  font-size: 12px;
}

.game-tag-input__toggle-icon--open {
  transform: rotate(90deg);
}

.game-tag-input__all-tags-list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
  padding: var(--space-2);
  background: linear-gradient(135deg, var(--color-wood-700), var(--color-wood-600));
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-md);
}

.game-tag-input__pickable-tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: var(--radius-full);
  font-family: var(--font-body);
  font-size: var(--font-size-body-sm);
  background: var(--color-parchment-100);
  color: var(--color-text-primary);
  border: 1px solid var(--color-parchment-300);
  cursor: pointer;
  transition: all var(--transition-fast);
  line-height: 1.4;
}

.game-tag-input__pickable-tag:hover {
  background: var(--color-fire-500);
  color: var(--color-parchment-100);
  border-color: var(--color-fire-600);
}
`, "",{"version":3,"sources":["webpack://./src/features/games/GameTagInput.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,6BAA6B;EAC7B,mCAAmC;EACnC,iCAAiC;EACjC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,sCAAsC;EACtC,uCAAuC;EACvC,kBAAkB;EAClB,oDAAoD;EACpD,6BAA6B;EAC7B,mCAAmC;EACnC,sCAAsC;EACtC,gCAAgC;EAChC,aAAa;EACb,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uCAAuC;EACvC,iBAAiB;EACjB,oDAAoD;EACpD,iFAAiF;EACjF,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6EAA6E;EAC7E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,sCAAsC;EACtC,uCAAuC;EACvC,gBAAgB;EAChB,oDAAoD;EACpD,4BAA4B;EAC5B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,mCAAmC;EACnC,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,iFAAiF;EACjF,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iCAAiC;EACjC,6BAA6B;EAC7B,mCAAmC;EACnC,sCAAsC;EACtC,gCAAgC;EAChC,4CAA4C;EAC5C,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;AACrC","sourcesContent":[".game-tag-input {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n/* Selected tags chips */\n.game-tag-input__selected {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-1);\n}\n\n.game-tag-input__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: var(--radius-full);\n  font-family: var(--font-body);\n  font-size: var(--font-size-body-sm);\n  background: var(--color-fire-500);\n  color: var(--color-parchment-100);\n  line-height: 1.4;\n}\n\n.game-tag-input__chip-remove {\n  background: none;\n  border: none;\n  color: var(--color-parchment-100);\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0 2px;\n  line-height: 1;\n  opacity: 0.8;\n}\n\n.game-tag-input__chip-remove:hover {\n  opacity: 1;\n}\n\n/* Input row: field + submit button */\n.game-tag-input__field-wrap {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n}\n\n.game-tag-input__field {\n  flex: 1;\n  min-width: 0;\n  padding: var(--space-2) var(--space-3);\n  border: 2px solid var(--color-wood-600);\n  border-right: none;\n  border-radius: var(--radius-md) 0 0 var(--radius-md);\n  font-family: var(--font-body);\n  font-size: var(--font-size-body-sm);\n  background: var(--color-parchment-100);\n  color: var(--color-text-primary);\n  outline: none;\n  transition: border-color var(--transition-fast);\n  box-sizing: border-box;\n}\n\n.game-tag-input__field:focus {\n  border-color: var(--color-fire-500);\n}\n\n.game-tag-input__field:focus + .game-tag-input__submit-btn {\n  border-color: var(--color-fire-500);\n}\n\n.game-tag-input__submit-btn {\n  flex-shrink: 0;\n  width: 40px;\n  border: 2px solid var(--color-wood-600);\n  border-left: none;\n  border-radius: 0 var(--radius-md) var(--radius-md) 0;\n  background: linear-gradient(135deg, var(--color-wood-700), var(--color-wood-600));\n  color: var(--color-parchment-100);\n  font-size: 18px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background var(--transition-fast), opacity var(--transition-fast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.game-tag-input__submit-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, var(--color-fire-600), var(--color-fire-500));\n}\n\n.game-tag-input__submit-btn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n/* Autocomplete suggestions dropdown */\n.game-tag-input__suggestions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: var(--color-parchment-100);\n  border: 2px solid var(--color-wood-600);\n  border-top: none;\n  border-radius: 0 0 var(--radius-md) var(--radius-md);\n  box-shadow: var(--shadow-md);\n  z-index: var(--z-dropdown);\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.game-tag-input__suggestion {\n  display: block;\n  width: 100%;\n  padding: var(--space-2) var(--space-3);\n  border: none;\n  background: none;\n  font-family: var(--font-body);\n  font-size: var(--font-size-body-sm);\n  color: var(--color-text-primary);\n  text-align: left;\n  cursor: pointer;\n  transition: background var(--transition-fast);\n}\n\n.game-tag-input__suggestion:hover {\n  background: var(--color-wood-600);\n  color: var(--color-parchment-100);\n}\n\n/* Collapsible all-tags section */\n.game-tag-input__all-tags {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.game-tag-input__toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1);\n  background: none;\n  border: none;\n  padding: var(--space-1) 0;\n  font-family: var(--font-body);\n  font-size: var(--font-size-body-sm);\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  user-select: none;\n  transition: color var(--transition-fast);\n}\n\n.game-tag-input__toggle-btn:hover {\n  color: var(--color-fire-600);\n}\n\n.game-tag-input__toggle-icon {\n  display: inline-block;\n  transition: transform var(--transition-fast);\n  font-size: 12px;\n}\n\n.game-tag-input__toggle-icon--open {\n  transform: rotate(90deg);\n}\n\n.game-tag-input__all-tags-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-1);\n  padding: var(--space-2);\n  background: linear-gradient(135deg, var(--color-wood-700), var(--color-wood-600));\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-md);\n}\n\n.game-tag-input__pickable-tag {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: var(--radius-full);\n  font-family: var(--font-body);\n  font-size: var(--font-size-body-sm);\n  background: var(--color-parchment-100);\n  color: var(--color-text-primary);\n  border: 1px solid var(--color-parchment-300);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  line-height: 1.4;\n}\n\n.game-tag-input__pickable-tag:hover {\n  background: var(--color-fire-500);\n  color: var(--color-parchment-100);\n  border-color: var(--color-fire-600);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
